"use strict";

import axios from 'axios';

const axiosInstance = axios.create ({
    baseURL : window.location.origin + '/api/v1'
})

let token = window.gCsrfToken || null;
if ( token !== null && token.content )
    axiosInstance.defaults.headers.common['X-CSRF-TOKEN'] = token.content;

axiosInstance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axiosInstance.CancelToken = axios.CancelToken;
axiosInstance.isCancel = axios.isCancel;

axiosInstance.interceptors.response.use((response) => {
    return response;
}, err => {
    if(axios.isCancel(err))
        return Promise.reject(err);
    const error = err.response;
    if (!!error) {
        if(error.status === 401){
            console.error('Unauthorized');
            window.location = window.location.origin + '/echeck/accounts';
        }
        if(error.status === 419){
            console.error('Page timed out');
            window.location.reload();
        }
        return Promise.reject(error);
    }
    return Promise.reject(error);
});
export default axiosInstance;
